import axios from 'axios';

export async function toggleGeoLicenses(): Promise<boolean> {
  const url = `/api/analyzer-modules/toggle-geo`;

  try {
    const { data } = await axios.post(url);
    return data as boolean;
  } catch (err) {
    throw err;
  }
}
